// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".resize-container[data-v-9f127660],.resize-iframe[data-v-9f127660]{width:100%;height:100%}.resize-container[data-v-9f127660]{position:relative;height:0}.resize-iframe[data-v-9f127660]{position:absolute;z-index:-1;left:0;top:0;min-height:1px}", ""]);
// Exports
module.exports = exports;
